// eslint-disable-next-line no-undef
const { motion, AnimatePresence } = require('framer-motion');
import { useRouter } from 'next/router';
import React, { useEffect, useMemo, useRef } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import useTriggerChangeTopHeightMobile from '../../../../hooks/useTriggerChangeTopHeightMobile';
import useTriggerInitialFilterOptions from '../../../../hooks/useTriggerInitialFilterOptions';
import { filtersCounter, saveFilteredOptions, setSortType } from '@/redux/actions';
import { SortList } from '@/utils/constants';
import { MobileSortByArrow } from '@/assets/svgExports/MobileSortByArrow';
import { MobileFilterIcon } from '@/assets/svgExports/MobileFilterIcon';
import { DropDownArrowSort } from '@/assets/svgExports/DropDownArrowSort';
import useIsComponentMounted from '@/utils/useIsComponentMounted';
import {
  AdvMiddleBodyContainer,
  AdvMiddleBodyWrapper,
  DropDownArrowContainer,
  FilterCtaContainer,
  FilterIconContainer,
  FilterText,
  LeftSection,
  MiddleBodyOverflow,
  MiddleSection,
  MobileLeftSectionContainer,
  MobileSortHeadingContainer,
  MobileSortHeadingText,
  MobileSortIcon,
  MobileSortIconContainer,
  SortByCtaContainer,
  SortByDropDownContainer,
  SortByDropDownListElement,
  SortByDropDownListInput,
  SortByDropDownListLabel,
  SortByTitle,
  SortFilterWrapper,
} from './AdvanceCatalogMiddleBody.styles';
import AllCategoriesItems from './Components/AllCategoriesItems/AllCategoriesItems';
import AllCollectionsItems from './Components/AllCollectionsItems/AllCollectionsItems';
import FilterDrawer from './Components/FilterDrawer/FilterDrawer';
import SortAndFilteredItems from './Components/SortAndFilteredItems/SortAndFilteredItems';
import { setMB7SortAndFilterConfig } from './utils';
import { useSSRSelector } from '@/redux/ssrStore';
import SortAndFilter from '../../Widgets2.0/SortAndFilter';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { COMMON_LAYOUT_TYPE } from '../../Widgets2.0/ListPresentation/components/Testimonials/Constants';
import SortAndFilterMobile from '../../Widgets2.0/SortAndFilter/SortAndFilterMobile';
import { isMobileDevice } from 'src/components/WidgetMaker/WidgetDnD/isMobileDevice';
import FilterHeading from '../../Widgets2.0/SortAndFilter/Component/FilterHeading';
import { HEADING_TYPE_IMAGE } from '../../Widgets2.0/SortAndFilter/constant';
import {
  getFilterTitleStyle,
  getFilterOptionStyle,
} from '../../Widgets2.0/SortAndFilter/utils';
import { twMerge } from 'tailwind-merge';
import AdvanceCatalogMiddleBody from './AdvanceCatalogMiddleBody';
import { filterIcon } from '../../Widgets2.0/SortAndFilter/svg/svgList';
import { buttonStyle, globalStyleValue } from 'src/utils/globalStyleHelper';

function AdvanceCatalogMiddleBody1(props) {
  const isMobile = isMobileDevice();
  const dispatch = useDispatch();
  const router = useRouter();
  const [showSortByDropDown, setShowSortByDropDown] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const [showFilterDrawerDelay, setShowFilterDrawerDelay] = useState(false);
  const [mobilePrevFilterOption, setMobilePrevFilterOption] = useState([]);
  const [showSortForMobile, setShowSortForMobile] = useState(false);
  const [isSortFilterOptionsActive, setIsSortFilterOptionsActive] = useState(false);
  const [showFilterData, setShowFilterData] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showRef, setShowRef] = useState(false);
  const sortAndFilterRef = useRef(null);
  const [isViewMore, setIsViewMore] = useState(false);
  const [selectedFilterInfo, setSelectedFilterInfo] = useState({});
  const {
    widgetContextState: { isBuilder, pageStyle, globalStyle },
    widgetContextActions: { setWidgetsByRoute },
  } = useWidgetDndContextData();
  const { store, collections, categories, jsonWidgetsReducer } = useSSRSelector(
    (state) => ({
      categories: state.catalogReducer?.categories,
      collections: state.catalogReducer.collections,
      store: state.storeReducer?.store,
      jsonWidgetsReducer: state.jsonWidgetsReducer,
    })
  );

  const themeColor = isBuilder
    ? { theme: { colors: { primary_color: globalStyle?.color?.themeColor } } }
    : store;
  const boxRadius = buttonStyle(globalStyle, 4, true);
  const borderRadiusVal = globalStyleValue(boxRadius?.borderRadius);

  const CollectionOrCategoryId = isBuilder
    ? selectedCatCol?.id
    : router?.query?.cid || router?.query?.collectionId;

  const selectedCollectionCategory = useMemo(() => {
    if (router?.query?.cid) {
      const selectedCategory = categories.find(
        (categoryItem) => categoryItem?.id == router?.query?.cid
      );
      return selectedCategory;
    } else {
      const selectedCollection = collections.find(
        (collection) => collection?.id == router?.query?.collectionId
      );
      return selectedCollection;
    }
  }, [CollectionOrCategoryId]);
  const middleBodyRef = useRef();
  const middleBodyContainerRef = useRef();
  const isComponentMounted = useIsComponentMounted();
  const isCollection = collections?.length ? true : false;
  const selectedCatCol = isBuilder
    ? getSelectedId()
    : { data: selectedCollectionCategory };
  const { filterAppliedCounter, sortType, filteredOptions, headerRef } = useSelector(
    (state) => ({
      filterAppliedCounter: state.catalogReducer.filterAppliedCounter,
      sortType: state.catalogReducer.sortType,
      filteredOptions: state.catalogReducer.filteredOptions,
      headerRef: state.commonReducer?.headerRef,
    })
  );

  const desktopLayout = pageStyle?.sortAndFilter?.layout_desktop;
  const isLayout1 = desktopLayout === COMMON_LAYOUT_TYPE.ONE;
  const isLayout2 = desktopLayout === COMMON_LAYOUT_TYPE.TWO;
  const isLayout3 = desktopLayout === COMMON_LAYOUT_TYPE.THREE;
  const currentWidgetType = isCollection
    ? pageStyle?.caligraphyCollection
    : pageStyle?.caligraphyCategory;
  const isHeadingTypeImage = currentWidgetType?.heading_type === HEADING_TYPE_IMAGE;
  const isOldLayoutSelected =
    desktopLayout === COMMON_LAYOUT_TYPE.ZERO || !desktopLayout || !pageStyle;

  /**
   * checks when to show sortAndFilter Cta in mobile base on height
   * from bottom and top of middleBody.
   */
  // const showSortAndFilterMobileCta = useTriggerChangeTopHeightMobile(
  //   middleBodyRef,
  //   isSortFilterOptionsActive,
  //   150,
  //   360
  // );

  useTriggerInitialFilterOptions(!CollectionOrCategoryId);

  useEffect(() => {
    const container = isBuilder ? props.widgetRef?.current : window;
    const target = sortAndFilterRef.current;

    const handleScroll = () => {
      if (!container || !target) return;
      const targetRect = target.getBoundingClientRect();
      if (targetRect.top + target.clientHeight < 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [showRef]);

  useEffect(() => {
    setShowRef(true);
  }, []);

  useEffect(() => {
    setIsSortFilterOptionsActive(showSortByDropDown || showFilterDrawer);
  }, [showSortByDropDown, showFilterDrawer]);

  // This sets new builder's sort & filter widget into context
  useEffect(() => {
    if (!isBuilder) {
      const payload = {
        routeName: 'Collection',
        routeConfigs: {
          widgets: jsonWidgetsReducer.widgets,
          jsonPageWidgetSchema: jsonWidgetsReducer.jsonPageWidgetData,
          style: jsonWidgetsReducer.pageStyle,
        },
      };
      setWidgetsByRoute(payload);
    }
  }, []);

  useEffect(() => {
    return () => {
      dispatch(filtersCounter(0, true));
    };
  }, []);

  /**
   * on mobile if filterDrawer is Active stop
   * Body from overflowing
   */

  useEffect(() => {
    if (isSortFilterOptionsActive && isMobile) {
      document.getElementsByTagName('body')[0].style.overflowY = 'hidden';
      setTimeout(() => {
        middleBodyRef.current.scrollIntoView();
      }, 600);
    } else document.getElementsByTagName('body')[0].style.overflowY = 'auto';

    return () => {
      document.getElementsByTagName('body')[0].style.overflowY = 'auto';
    };
  }, [isSortFilterOptionsActive]);

  function getSelectedId(returnId = true) {
    const { listItem = [] } =
      pageStyle?.categoryCollectionData?.listPresentation?.contentItems || {};
    const selectedCollCat = listItem?.find((item) => item?.isVisible);
    return selectedCollCat;
  }

  function handleSortByClick() {
    // simulates apply condition in Mobile when FilterDrawer is open
    if (isMobile && showFilterDrawer) {
      setShowFilterDrawer(!showFilterDrawer);
      setTimeout(() => {
        setShowFilterDrawerDelay(!showFilterDrawerDelay);
      }, 525);
      setMobilePrevFilterOption(filteredOptions);
      return;
    }
    // simulates apply condition in case when sorting drowdown is active
    else if (isMobile && showSortByDropDown) {
      setShowSortByDropDown(!showSortByDropDown);
      setShowSortForMobile(!showSortForMobile);
      return;
    } else setShowSortByDropDown(!showSortByDropDown);
  }

  useEffect(() => {
    if (isMobile && headerRef.current) {
      showFilterDrawer
        ? (headerRef.current.style.display = 'none')
        : (headerRef.current.style.display = '');
    }
  }, [showFilterDrawer]);

  function getCorrectedFilterAppliedCounter() {
    let newFilteredAppliedCounter = 0;
    mobilePrevFilterOption &&
      mobilePrevFilterOption.forEach((item) => {
        !!item?.sub_filter?.length &&
          item?.sub_filter.forEach((subFilterItem) => {
            if (subFilterItem?.is_selected) {
              newFilteredAppliedCounter++;
            }
          });
      });
    dispatch(filtersCounter(newFilteredAppliedCounter, true));
  }

  function getFilterOptionSelectedArray(localfilterOptions) {
    const selectedSubFilters = [];
    !!localfilterOptions?.length &&
      localfilterOptions.forEach((filterOptionItem) => {
        !!filterOptionItem.sub_filters?.length &&
          filterOptionItem.sub_filters.forEach((item) => {
            item?.is_selected && selectedSubFilters.push(item?.name);
          });
      });
    return selectedSubFilters;
  }

  /**
   * checks whether two array are equal or not
   * @param {*} prevFilterOptions FilterOption State in Mobile before Current Session
   * @param {*} currentFilterOptions FilterOption State in Current Session
   * @returns {boolean} if both arrays are same return true else false
   */

  function isFilterOptionAsPrevious(prevFilterOptions, currentFilterOptions) {
    const prevSelectedSubFilters = getFilterOptionSelectedArray(prevFilterOptions);
    const currentSelectedSubFilters = getFilterOptionSelectedArray(currentFilterOptions);
    if (prevSelectedSubFilters.length === currentSelectedSubFilters.length) {
      return prevSelectedSubFilters.every((element, index) => {
        if (element === currentSelectedSubFilters[index]) {
          return true;
        }
        return false;
      });
    }
    return false;
  }

  /**
   * when filter drawer close in mobile the checked states need to be reset
   * to previous state so does filterApplied counter
   * @returns {*}
   */

  function handleShowFilterDrawerAndClose() {
    if (isMobile && showSortByDropDown) {
      showSortByDropDown && handleSortByClick();
      showFilterDrawer && setShowFilterDrawer(!showFilterDrawer);
      return;
    } else if (isMobile && showFilterDrawerDelay) {
      if (!isFilterOptionAsPrevious(mobilePrevFilterOption, filteredOptions))
        getCorrectedFilterAppliedCounter();
      !!mobilePrevFilterOption?.length &&
        dispatch(saveFilteredOptions(mobilePrevFilterOption));
    }
    setShowFilterDrawer(!showFilterDrawer);
    setTimeout(() => {
      setShowFilterDrawerDelay(!showFilterDrawerDelay);
    }, 525);
  }

  function handleSortItemClick(e, sortItem) {
    e?.stopPropagation();
    dispatch(setSortType(sortItem.type));
    setMB7SortAndFilterConfig({ sortTypeChanged: true });
    !isMobile && handleSortByClick();
  }

  function removeUnwantedFilter(filterList) {
    return filterList?.filter((data) => data?.name !== 'Collections');
  }

  function getNameFromSortType() {
    return (
      SortList &&
      !!SortList?.length &&
      SortList.find((item) => item.type === sortType)
    )?.name;
  }
  function renderFilterDrawer() {
    return isMobile ? (
      <MobileLeftSectionContainer>
        <LeftSection>
          <FilterDrawer handleShowFilterDrawer={handleShowFilterDrawerAndClose} />
        </LeftSection>
      </MobileLeftSectionContainer>
    ) : (
      <LeftSection>
        <FilterDrawer handleShowFilterDrawer={handleShowFilterDrawerAndClose} />
      </LeftSection>
    );
  }

  function renderFilterDrawerDesktop() {
    return (
      <AnimatePresence>
        {showFilterDrawer && (
          <motion.div
            key="filterDrawer"
            initial={{ opacity: 0, x: -100, zIndex: 3 }}
            transition={{ duration: 0.5 }}
            animate={{ opacity: 1, x: 0, zIndex: 3 }}
            exit={{ opacity: 0, x: -100, zIndex: 3 }}
          >
            {renderFilterDrawer()}
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  function renderFilterDrawerMobile() {
    return (
      <AnimatePresence>
        {showFilterDrawer && (
          <motion.div
            key="filterDrawer"
            initial={{ opacity: 0, x: 0, zIndex: -1 }}
            transition={{ duration: 0.5 }}
            animate={{ opacity: 1, x: 0, zIndex: 3 }}
            exit={{ opacity: 0, x: 0, zIndex: -1 }}
          >
            {renderFilterDrawer()}
          </motion.div>
        )}
      </AnimatePresence>
    );
  }

  function renderLeftSection() {
    return (
      <>
        {isMobile ? renderFilterDrawerMobile() : renderFilterDrawerDesktop()}
        {!(showFilterDrawer ? showFilterDrawer : showFilterDrawerDelay) && !isMobile && (
          <LeftSection visibilty={'hidden'} />
        )}
      </>
    );
  }

  function renderNewFilterLeftSection() {
    return (
      <SortAndFilter
        filterOption={removeUnwantedFilter(filteredOptions)}
        showFilters={showFilterData}
        hideFilter={setShowFilterData}
        selectedFilterInfo={selectedFilterInfo}
        setSelectedFilterInfo={setSelectedFilterInfo}
        isViewMore={isViewMore}
        setIsViewMore={setIsViewMore}
      />
    );
  }

  function renderFilterCta() {
    return (
      <FilterCtaContainer
        id="FilterCtaContainer"
        onClick={handleShowFilterDrawerAndClose}
        showFilterDrawer={isMobile ? false : showFilterDrawer}
      >
        <FilterIconContainer>
          {isMobile ? (
            isSortFilterOptionsActive ? null : (
              <MobileFilterIcon />
            )
          ) : (
            <MobileFilterIcon />
          )}
        </FilterIconContainer>
        <FilterText>
          {isMobile ? (isSortFilterOptionsActive ? 'Close' : 'Filters') : 'Filters'}
        </FilterText>
      </FilterCtaContainer>
    );
  }

  function renderSortArrowIcon() {
    return (
      <MobileSortIconContainer>
        <MobileSortIcon>
          <MobileSortByArrow />
        </MobileSortIcon>
        <MobileSortIcon rotate={true}>
          <MobileSortByArrow />
        </MobileSortIcon>
      </MobileSortIconContainer>
    );
  }

  function renderMobileSortByHeading() {
    return (
      <MobileSortHeadingContainer>
        <MobileSortHeadingText>Sort By</MobileSortHeadingText>
      </MobileSortHeadingContainer>
    );
  }

  function sortByDesktopText() {
    return (
      <span className="flex flex-row">
        Sort By:
        <span className="ml6px fw6 flex justify-center align-center">
          {getNameFromSortType()}
        </span>
      </span>
    );
  }

  function newSortByDesktopText() {
    return (
      <div style={{ ...getFilterTitleStyle(pageStyle, isMobile) }}>
        {`Sort By: ${getNameFromSortType()}`}
      </div>
    );
  }

  function renderSortByCta() {
    return (
      <SortByCtaContainer onClick={handleSortByClick}>
        <SortByTitle
          storeInfo={store}
          isApplyActive={isMobile && isSortFilterOptionsActive}
        >
          {isMobile && (isSortFilterOptionsActive ? null : renderSortArrowIcon())}
          {isMobile ? (
            isSortFilterOptionsActive ? (
              'Apply'
            ) : (
              'Sort By'
            )
          ) : (
            <>{sortByDesktopText()}</>
          )}

          {!isMobile && (
            <DropDownArrowContainer showSortByDropDown={showSortByDropDown}>
              <DropDownArrowSort />
            </DropDownArrowContainer>
          )}
        </SortByTitle>
        {showSortByDropDown && (
          <SortByDropDownContainer>
            {isMobile && renderMobileSortByHeading()}
            {SortList.map((sortItem) => {
              return (
                <SortByDropDownListElement
                  storeInfo={themeColor}
                  key={`Sort-DropDown-list-${sortItem.name}`}
                  onClick={(e) => {
                    handleSortItemClick(e, sortItem);
                  }}
                >
                  <SortByDropDownListInput
                    checked={sortItem.type === sortType ? true : false}
                    type="radio"
                  />
                  <SortByDropDownListLabel
                    isSelected={sortItem.type === sortType ? true : false}
                  >
                    {sortItem.name}
                  </SortByDropDownListLabel>
                </SortByDropDownListElement>
              );
            })}
          </SortByDropDownContainer>
        )}
      </SortByCtaContainer>
    );
  }

  function renderSortByCtaNew() {
    return (
      <SortByCtaContainer onClick={handleSortByClick}>
        <SortByTitle
          storeInfo={themeColor}
          style={{ borderRadius: !isLayout2 ? Number(borderRadiusVal) : '' }}
          isApplyActive={isMobile && isSortFilterOptionsActive}
          className={twMerge(
            isLayout2 ? '!tw-border-none !tw-px-[0px]' : '!tw-px-[20px]',
            'tw-w-max !tw-min-w-[0px] !tw-py-[8px]'
          )}
        >
          {isMobile && (isSortFilterOptionsActive ? null : renderSortArrowIcon())}
          {isMobile ? (
            isSortFilterOptionsActive ? (
              'Apply'
            ) : (
              'Sort By'
            )
          ) : (
            <>{newSortByDesktopText()}</>
          )}

          {!isMobile && (
            <DropDownArrowContainer
              className="!tw-ml-[6px] tw-mt-[2px]"
              showSortByDropDown={showSortByDropDown}
            >
              <DropDownArrowSort />
            </DropDownArrowContainer>
          )}
        </SortByTitle>
        {showSortByDropDown && (
          <SortByDropDownContainer className="tw-right-[15px] tw-ml-[0px] tw-flex tw-flex-col tw-gap-[16px] tw-rounded-[8px] tw-px-[16px] tw-py-[20px]">
            {isMobile && renderMobileSortByHeading()}
            {SortList.map((sortItem) => {
              return (
                <SortByDropDownListElement
                  className=" !tw-mb-[0px] !tw-ml-[0px] tw-w-[220px]"
                  storeInfo={themeColor}
                  key={`Sort-DropDown-list-${sortItem.name}`}
                  onClick={(e) => {
                    handleSortItemClick(e, sortItem);
                  }}
                >
                  <SortByDropDownListInput
                    checked={sortItem.type === sortType ? true : false}
                    type="radio"
                  />
                  <div
                    style={{ ...getFilterOptionStyle(pageStyle, isMobile) }}
                    className={`${sortItem.type === sortType ? '!tw-font-bold' : ''} tw-ml-[8px]`}
                  >
                    {sortItem.name}
                  </div>
                </SortByDropDownListElement>
              );
            })}
          </SortByDropDownContainer>
        )}
      </SortByCtaContainer>
    );
  }

  function renderNewFilterCta() {
    return (
      <div
        style={{ borderRadius: Number(borderRadiusVal) }}
        onClick={() => setShowFilterData(true)}
        className="tw-flex tw-cursor-pointer tw-items-center tw-gap-[10px] tw-border tw-border-solid tw-border-[#111C361F] tw-px-[20px] tw-py-[4px]"
      >
        <div>{filterIcon()}</div>
        <div style={{ ...getFilterTitleStyle(pageStyle, isMobile) }}>{'Filters'}</div>
      </div>
    );
  }

  function renderSortFilterWrapper() {
    return (
      <SortFilterWrapper
        ref={sortAndFilterRef}
        className={`tw-flex ${isLayout1 ? '!tw-items-center' : '!tw-items-start'} !tw-z-10 ${isLayout2 ? 'tw-z-1 tw-sticky tw-top-[50px]' : ''}`}
      >
        {isLayout3 && filteredOptions && renderNewFilterCta()}
        {isLayout3 && !filteredOptions && <div></div>}
        {isLayout2 && renderNewFilterLeftSection()}
        {isLayout1 && !isHeadingTypeImage && (
          <FilterHeading selectedCatCol={selectedCatCol} isCollection={isCollection} />
        )}
        {isLayout1 && isHeadingTypeImage && <div></div>}
        {renderSortByCtaNew()}
      </SortFilterWrapper>
    );
  }

  function renderSortFilterWrapperScroll() {
    return (
      <SortFilterWrapper
        style={{
          top: isBuilder ? headerRef?.current?.clientHeight + 66 : 0,
          margin: '0 -16px',
          width: isBuilder ? middleBodyContainerRef?.current?.clientWidth : '100%',
        }}
        className={`tw-fixed !tw-z-10 tw-flex !tw-items-start tw-bg-white`}
      >
        <div
          style={{
            maxWidth:
              middleBodyContainerRef?.current?.clientWidth > 1468
                ? 1468
                : middleBodyContainerRef?.current?.clientWidth - 32,
          }}
          className="tw-ml-[16px] tw-flex tw-w-[100%] tw-items-start tw-justify-between tw-pt-[30px]"
        >
          {isLayout2 && renderNewFilterLeftSection()}
          {renderSortByCtaNew()}
        </div>
      </SortFilterWrapper>
    );
  }

  function sortAndFilterCtaTab() {
    const showFullWidthHeading = isLayout3 || isLayout2;
    // if (isMobile && !showSortAndFilterMobileCta) return null;
    return (
      isComponentMounted &&
      (isOldLayoutSelected ? (
        <SortFilterWrapper className=" !tw-z-10 ">
          {filteredOptions?.length > 0 && renderFilterCta()}
          {filteredOptions?.length === 0 && <div></div>}
          {renderSortByCta()}
        </SortFilterWrapper>
      ) : !isMobile ? (
        <div
          className={`${showFullWidthHeading ? 'tw-flex tw-flex-col tw-gap-[36px]' : ''}`}
        >
          {(isLayout3 ||
            isLayout2 ||
            (isHeadingTypeImage && desktopLayout !== COMMON_LAYOUT_TYPE.ONE)) && (
            <FilterHeading selectedCatCol={selectedCatCol} isCollection={isCollection} />
          )}
          {renderSortFilterWrapper()}
          {isSticky && isLayout2 && renderSortFilterWrapperScroll()}
        </div>
      ) : (
        <SortAndFilterMobile
          filterOption={removeUnwantedFilter(filteredOptions)}
          showFilters={showFilterData}
          isCollection={isCollection}
          hideFilter={setShowFilterData}
          selectedCatCol={selectedCatCol}
          containerRef={props?.widgetRef}
          handleSortItemClick={handleSortItemClick}
          selectedFilterInfo={selectedFilterInfo}
          setSelectedFilterInfo={setSelectedFilterInfo}
          isViewMore={isViewMore}
          setIsViewMore={setIsViewMore}
        />
      ))
    );
  }

  function renderCategoryItemList() {
    return (
      isComponentMounted && (
        <MiddleBodyOverflow isMobile={isMobile}>
          <AllCategoriesItems
            showSortByDropDown={showSortByDropDown}
            showFilterDrawer={showFilterDrawer}
          />
        </MiddleBodyOverflow>
      )
    );
  }

  function renderSortAndFilteredItems() {
    return (
      isComponentMounted && (
        <MiddleBodyOverflow isMobile={isMobile}>
          <SortAndFilteredItems
            middleBodyContainerRef={middleBodyContainerRef}
            showSortByDropDown={showSortByDropDown}
            showFilterDrawer={showFilterDrawer}
            selectedId={selectedCatCol?.id}
          />
        </MiddleBodyOverflow>
      )
    );
  }

  const collectionCategoryItemsList = () => {
    return (
      <div
        className={`sortAndFilterCollection collection-category-items ${
          isMobile ? '' : 'mr76px'
        }`}
      >
        <AllCollectionsItems
          showFilterDrawer={showFilterDrawer}
          showSortByDropDown={showSortByDropDown}
        />
      </div>
    );
  };

  function renderMiddleBodyAnimated() {
    return (
      <>
        {isMobile ? (
          renderMiddleSection()
        ) : (
          <motion.div
            key="middleBodyAnimated"
            initial={{ x: 0 }}
            transition={{ duration: 0.5 }}
            animate={showFilterDrawer ? { x: 0 } : {}}
            className="tw-w-full"
          >
            {renderMiddleSection()}
          </motion.div>
        )}
      </>
    );
  }

  function renderMiddleSection() {
    return (
      <MiddleSection ref={middleBodyRef}>
        <div className="tw-relative">
          {sortAndFilterCtaTab()}
          {filterAppliedCounter ||
          sortType ||
          CollectionOrCategoryId ||
          selectedCatCol?.id
            ? renderSortAndFilteredItems()
            : isCollection
              ? collectionCategoryItemsList()
              : renderCategoryItemList()}
        </div>
      </MiddleSection>
    );
  }

  if (isOldLayoutSelected) {
    return <AdvanceCatalogMiddleBody />;
  }

  return (
    <div>
      {isLayout1 && isHeadingTypeImage && !isMobile && (
        <FilterHeading selectedCatCol={selectedCatCol} isCollection={isCollection} />
      )}
      <AdvMiddleBodyWrapper
        className={`!tw-mt-[0px] ${isLayout1 && !isMobile ? '!tw-pt-[68px]' : ''}`}
        ref={middleBodyContainerRef}
      >
        {isOldLayoutSelected
          ? renderLeftSection()
          : desktopLayout !== COMMON_LAYOUT_TYPE.TWO && !isMobile
            ? renderNewFilterLeftSection()
            : null}
        <AdvMiddleBodyContainer>{renderMiddleBodyAnimated()}</AdvMiddleBodyContainer>
      </AdvMiddleBodyWrapper>
    </div>
  );
}

export default AdvanceCatalogMiddleBody1;
